import React, { useState, useEffect } from "react";
// Assets
import influencerImage from "../../../../../assets/influencerImage.png";
import influencerTwitter from "../../../../../assets/influencerTwitter.png";
import influencerPlaceholder from "../../../../../assets/influencerPlaceholder.png";
import CloseIcon from "@mui/icons-material/Close";

function AddedInfluencer({ influencer = [], setInfluencer }) {
  // Function to delete item on button click
  const deleteItem = (key) => {
    setInfluencer(influencer.filter((item) => item.uniqueID !== key));
  };

  return (
    <div>
      <div className="card influencer-card">
        {influencer.map((item) => {
          return (
            <div className="card influencer-card">
              <div>
                <img
                  src={item.imageUrl}
                  onError={(e) => {
                    e.target.src = influencerPlaceholder;
                  }}
                  alt="Influencer"
                  className="influencer-image"
                />
                <div className="influencer-details">
                  <img src={influencerTwitter} alt="Influencer Twitter" />
                  {/* <p>{item.key}</p> */}
                  <p className="yellow">{item.name}</p>
                  <p className="followers">{item.followers}</p>
                </div>
              </div>

              <button
                className="cancel-influencer"
                onClick={(e) => {
                  e.preventDefault();
                  console.log(item.uniqueID);
                  deleteItem(item.uniqueID);
                }}
              >
                <CloseIcon />
              </button>
            </div>
          );
        })}
        </div>
    </div>
  );
}

export default AddedInfluencer;
